
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150 100"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#D5192A","d":"M0 0h150v100H0z"}}),_c('path',{attrs:{"fill":"#FFDE03","d":"M25 31.067l-8.817 6.068 3.047-10.26-8.496-6.51 10.7-.274L25 10l3.566 10.091 10.7.274-8.496 6.51 3.047 10.26zM48.79 10.954l-2.822.424 1.93-2.103-1.275-2.554 2.596 1.186 2.034-2.002-.324 2.835 2.532 1.317-2.797.567-.47 2.815zM58.417 21.702l-2.83-.37 2.435-1.49-.522-2.806 2.17 1.855 2.507-1.364-1.094 2.637 2.071 1.963-2.845-.226-1.227 2.577zM59.5 36.118l-2.351 1.618L57.96 35l-2.265-1.736 2.853-.073.951-2.691.951 2.691 2.853.073L61.04 35l.812 2.736zM48.691 46.901l-2.845.226 2.071-1.963-1.094-2.637 2.508 1.364 2.169-1.855-.522 2.806 2.435 1.49-2.83.37-.665 2.776z"}})])])
          )
        }
      }
    